import { Route, Routes } from "react-router-dom";

import CompetitionHeaderLayout from "./components/CompetitionHeaderLayout";
import AttemptsScreen from "./components/screens/AttemptsScreen/AttemptsScreen";
import EditEntryScreen from "./components/screens/EditEntryScreen/EditEntryScreen";
import EntriesScreen from "./components/screens/EntriesScreen/EntriesScreen";
import MainScreen from "./components/screens/MainScreen";
import RenumberRoutesScreen from "./components/screens/RenumberRoutesScreen/RenumberRoutesScreen";
import RouteScreen from "./components/screens/RouteScreen";
import DashboardScreen from "./modules/dashboard/DashboardScreen";
import AgeScreen from "./modules/onboarding/components/screens/AgeScreen";
import CompetitorDetailScreen from "./modules/onboarding/components/screens/CompetitorDetailScreen/CompetitorDetailScreen";
import CompetitorListScreen from "./modules/onboarding/components/screens/CompetitorListScreen/CompetitorListScreen";
import CompetitorNumberScreen from "./modules/onboarding/components/screens/CompetitorNumberScreen/CompetitorNumberScreen";
import {
  EntryEmailScreen,
  EntryLoginScreen,
  EntryRegisterScreen,
} from "./modules/onboarding/components/screens/EntryAccountScreens";
import InitialEntryScreen from "./modules/onboarding/components/screens/InitialEntryScreen";
import InitialJudgeScreen from "./modules/onboarding/components/screens/InitialJudgeScreen";
import {
  JudgeEmailScreen,
  JudgeLoginScreen,
  JudgeRegisterScreen,
} from "./modules/onboarding/components/screens/JudgeAccountScreens";
import JudgeConfirmScreen from "./modules/onboarding/components/screens/JudgeConfirmScreen/JudgeConfirmScreen";
import JudgeKidsScreen from "./modules/onboarding/components/screens/JudgeKidsScreen";
import ProfileScreen from "./modules/onboarding/components/screens/ProfileScreen/ProfileScreen";
import AssignAreasScreen from "./components/screens/AssignAreasScreen/AssignAreasScreen";

const AppRoutes = () => (
  <Routes>
    <Route path=":competitionUUID">
      <Route index element={<MainScreen />} />
      <Route path="dashboard" element={<DashboardScreen />}></Route>
      <Route path="entries">
        <Route index element={<EntriesScreen />} />
        <Route path=":userUUID" element={<EditEntryScreen />} />
      </Route>
      <Route path="enter" element={<CompetitionHeaderLayout />}>
        <Route index element={<InitialEntryScreen />} />
        <Route path="competitor-number" element={<CompetitorNumberScreen />} />
        <Route path="age" element={<AgeScreen />} />
        <Route path="email" element={<EntryEmailScreen />} />
        <Route path="register" element={<EntryRegisterScreen />} />
        <Route path="login" element={<EntryLoginScreen />} />
        <Route path="confirm" element={<ProfileScreen />} />
        <Route path="competitors">
          <Route index element={<CompetitorListScreen />} />
          <Route path="add" element={<CompetitorDetailScreen />} />
          <Route path=":profileUUID" element={<CompetitorDetailScreen />} />
        </Route>
      </Route>
      <Route path="admin">
        <Route index element={<InitialJudgeScreen />} />
        <Route path="login" element={<JudgeLoginScreen />} />
        {/* <Route path="bulk-edit" element={<BulkEditScreen />} /> */}
      </Route>
      <Route path="judge">
        <Route index element={<InitialJudgeScreen />} />
        <Route path="onboarding" element={<CompetitionHeaderLayout />}>
          <Route index element={<JudgeEmailScreen />} />
          <Route path="register" element={<JudgeRegisterScreen />} />
          <Route path="login" element={<JudgeLoginScreen />} />
          <Route path="kids" element={<JudgeKidsScreen />} />
          <Route path="confirm" element={<JudgeConfirmScreen />} />
        </Route>
        <Route path=":routeUUID">
          <Route index element={<RouteScreen />} />
          <Route path=":userUUID" element={<AttemptsScreen />} />
        </Route>
      </Route>
      <Route path="order-routes">
        <Route index element={<RenumberRoutesScreen />} />
      </Route>
      <Route path="manage-routes">
        <Route index element={<AssignAreasScreen />} />
        <Route path="areas" element={<AssignAreasScreen />} />
        <Route path="categories" element={<RenumberRoutesScreen />} />
      </Route>
    </Route>
  </Routes>
);

export default AppRoutes;
